// extracted by mini-css-extract-plugin
export default {"AppointmentsFilter":"AppointmentsFilter_AppointmentsFilter__OMQE4"};